module.exports = __webpack_public_path__ + "static/assets/08441388f5cbe3aae7841b1af318b4d3.svg";